// extracted by mini-css-extract-plugin
export default {"logoContainer":"logo_logoContainer__Jhw5C","logoImg":"logo_logoImg__Z-vo4"};